export const MESSAGE_ERROR_INTERNAL_SERVER =
  'Network error. Please try again later!';
